<template>
  <v-data-table :headers="headers"
                :items="items"
                :hide-default-footer="true"
                :options.sync="options"
                class="adminPortalTable">
    <template v-if="tableType === 'agents'" v-slot:body.prepend>
      <tr>
        <td :colspan="headers.length">
          <v-text-field class="searchFormInput"
                        :value="search"
                        single-line
                        hide-details
                        @input="debouncedSearch($event)">
            <template slot="prepend">
              <div :class="$style.searchIcon" />
            </template>
          </v-text-field>
        </td>
      </tr>
    </template>

    <template v-if="tableType === 'clients'" v-slot:body.prepend>
      <tr>
        <td></td>
        <td>
          <v-text-field class="searchFormInput"
                        v-model="searchByName"
                        single-line
                        hide-details
                        @input="debouncedSearchByName($event)">
            <template slot="prepend">
              <div :class="$style.searchIcon" />
            </template>
          </v-text-field>
        </td>
        <td>
          <v-text-field class="searchFormInput"
                        v-model="searchByEmail"
                        single-line
                        hide-details
                        @input="debouncedSearchByEmail($event)">
            <template slot="prepend">
              <div :class="$style.searchIcon" />
            </template>
          </v-text-field>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td v-if="isSuperAdmin">
          <v-text-field class="searchFormInput"
                        v-model="searchByCoach"
                        single-line
                        hide-details
                        @input="debouncedSearchByCoach($event)">
            <template slot="prepend">
              <div :class="$style.searchIcon" />
            </template>
          </v-text-field>
        </td>
        <td v-if="isSuperAdmin">
          <v-text-field class="searchFormInput"
                        v-model="searchByNegotiator"
                        single-line
                        hide-details
                        @input="debouncedSearchByNegotiator($event)">
            <template slot="prepend">
              <div :class="$style.searchIcon" />
            </template>
          </v-text-field>
        </td>
      </tr>
    </template>

    <template v-slot:item.fullName="{ item }">
      <router-link class="detailsLink"
                   :to="getItemLink(item)">
        {{ item.fullName }}
      </router-link>
    </template>

    <template v-if="isSuperAdmin" v-slot:item.coachName="{ item }">
      <router-link v-if="item.coachName"
                   class="detailsLink"
                   :to="'/agents/' + item.coachId">
        {{ item.coachName }}
      </router-link>
      <app-button v-if="isCoachAssignRequired(item)"
                  class="assignBtn"
                  @click="assignCoach(item)">
        Assign
      </app-button>
      <p v-if="!isCoachAssignRequired(item) && !item.coachName">
        Unpaid
      </p>
    </template>

    <template v-if="isSuperAdmin" v-slot:item.negotiatorName="{ item }">
      <router-link v-if="item.negotiatorName"
                   class="detailsLink"
                   :to="'/agents/' + item.negotiatorId">
        {{ item.negotiatorName }}
      </router-link>
      <app-button v-if="isNegotiatorAssignRequired(item)"
                  class="assignBtn"
                  @click="assignNegotiator(item)">
        Assign
      </app-button>
      <p v-if="!isNegotiatorAssignRequired(item) && !item.negotiatorName">
        Unpaid
      </p>
    </template>

    <template v-slot:item.resendInvitation="{ item }">
      <app-button class="resendBtn"
                  @click="resendInvitation($event, item)">
        Resend Invitation
      </app-button>
    </template>

    <template v-slot:item.cancelInvite="{ item }">
      <app-button class="cancelBtn"
                  @click="cancelInvite($event, item)">
        Cancel Invite
      </app-button>
    </template>
    <template v-slot:footer>
      <v-pagination class="pagination"
                    :value="page"
                    :length="pageCount"
                    :total-visible="10"
                    @input="changePage($event)"></v-pagination>
    </template>

  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROLES } from '@/constants';

export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    tableType: {
      type: String,
      default: 'agents',
    },
  },
  data() {
    return {
      search: '',
      searchByName: '',
      searchByEmail: '',
      searchByCoach: '',
      searchByNegotiator: '',
      options: {},
    };
  },
  methods: {
    getItemId(item) {
      return item.applicationId ? item.applicationId : item.id;
    },
    getItemLink(item) {
      return `/${this.$route.name}/${this.getItemId(item)}`;
    },
    isCoachAssignRequired(item) {
      return !!(item.isCoachRequired && !item.coachName);
    },
    isNegotiatorAssignRequired(item) {
      return !!(item.isNegotiatorRequired && !item.negotiatorName);
    },
    resendInvitation(e, item) {
      this.$emit('resendInvitation', { e, item });
    },
    cancelInvite(e, item) {
      this.$emit('cancelInvite', { e, item });
    },
    assignCoach(item) {
      this.$emit('assignCoach', item);
    },
    assignNegotiator(item) {
      this.$emit('assignNegotiator', item);
    },
    changePage(e) {
      this.$emit('changePage', e);
    },
    emitSearch(e) {
      this.$emit('search', e);
    },
    emitSearchByName(e) {
      this.searchByEmail = '';
      this.searchByCoach = '';
      this.searchByNegotiator = '';
      this.$emit('searchByName', e);
    },
    emitSearchByEmail(e) {
      this.searchByName = '';
      this.searchByCoach = '';
      this.searchByNegotiator = '';
      this.$emit('searchByEmail', e);
    },
    emitSearchByCoach(e) {
      this.searchByEmail = '';
      this.searchByName = '';
      this.searchByNegotiator = '';
      this.$emit('searchByCoach', e);
    },
    emitSearchByNegotiator(e) {
      this.searchByEmail = '';
      this.searchByCoach = '';
      this.searchByName = '';
      this.$emit('searchByNegotiator', e);
    },
    emitSortingOptions() {
      const sortingOptions = {
        orderBy: this.options.sortBy[0],
        desc: this.options.sortDesc[0],
      };
      this.$emit('sortingChanged', sortingOptions);
    },
  },
  computed: {
    ...mapGetters([
      'getRoles',
    ]),
    debouncedSearch() {
      return this.lodash.debounce(this.emitSearch, 500);
    },
    debouncedSearchByName() {
      return this.lodash.debounce(this.emitSearchByName, 500);
    },
    debouncedSearchByEmail() {
      return this.lodash.debounce(this.emitSearchByEmail, 500);
    },
    debouncedSearchByCoach() {
      return this.lodash.debounce(this.emitSearchByCoach, 500);
    },
    debouncedSearchByNegotiator() {
      return this.lodash.debounce(this.emitSearchByNegotiator, 500);
    },
    isSuperAdmin() {
      const roles = this.getRoles;
      return roles.includes(ROLES.SUPER_ADMIN);
    },
  },
  mounted() {
    this.$watch('options', () => this.emitSortingOptions(), { deep: true });
  },
};
</script>

<style lang="scss" module>
.searchIcon {
  width: 20px;
  height: auto;
  background-size: cover;
  background-position: center;
  background-image: url('@/assets/icons/ic_search.png');
}
</style>

<style lang="scss">
.adminPortalTable {
  th {
    font-size: 1.2rem;
    font-weight: 700;
  }
  td {
    font-size: 1.4rem;

    .detailsLink {
      color: #3a82df;
      font-weight: 700;
      text-decoration: none;
    }
  }

  .v-data-footer {
    font-size: 1.2rem;
    .v-data-footer__select .v-select__selections .v-select__selection--comma {
      font-size: 1.2rem;
    }
  }

  .assignBtn {
    border: none;
    color: #3a82df;
    font-weight: 700;
    font-style: normal;
    font-size: 1.4rem;
    background-color: transparent;

    &:hover,
    &:focus,
    &:active {
      background-color: transparent;
    }
  }

  p {
    font-size: 1.4rem;
    margin-bottom: 0;
  }

  .resendBtn {
    border: none;
    font-weight: 700;
    font-style: normal;
    font-size: 1.4rem;
    background-color: transparent;
  }

  .cancelBtn {
    border: none;
    color: #CC1515;
    font-weight: 700;
    font-style: normal;
    font-size: 1.4rem;
    background-color: transparent;
  }
}

.searchFormInput {
  position: relative;
  margin-left: 25px;

  .v-input__prepend-outer {
    position: absolute;
    top: 16px;
    left: -25px;
    width: 18px;
    height: 16px;
    margin: 0;
    padding: 0;
  }

  .v-input__control .v-input__slot::after,
  .v-input__control .v-input__slot::before {
    content: none;
  }

  .v-input__control .v-input__slot input {
    padding-bottom: 16px;
  }
}

.pagination li::before {
  content: none;
}
</style>
